import { useEffect, useMemo } from 'react'
import { LayoutPage } from '@/components/layout/page'
import { NoAccessError } from '@/lib/errors'
import { useIdCompany, useRBAC } from '@/lib/hooks'
import { hasProjectLevelRole } from '@/lib/rbac'
import { CreateDatabaseFallback } from '@/routes/databases/create-database/fallback'
import { CreateDatabaseForm } from '@/routes/databases/create-database/form'

export const CreateDatabasePage = () => {
  const { idCompany } = useIdCompany()
  const { rbac, rolesInCompany } = useRBAC()

  const hasCreateAccess = useMemo(
    () => rbac.company(idCompany).databases.create.can(),
    [rbac, idCompany]
  )
  const hasProjectAccess = useMemo(
    () => hasProjectLevelRole(rolesInCompany),
    [rolesInCompany]
  )

  useEffect(() => {
    if (!hasCreateAccess && !hasProjectAccess) {
      throw new NoAccessError()
    }
  }, [hasCreateAccess, hasProjectAccess])

  return (
    <LayoutPage
      browserTitle="Create database"
      fallback={<CreateDatabaseFallback />}
    >
      <CreateDatabaseForm />
    </LayoutPage>
  )
}
